import { supportRequirementService } from '@/modules/auth/services/SupportRequirementService';
import type Service from '@/types/Service';

export default function useSupportRequirement() {
  const supportRequirements = ref<Service[]>([]);
  const fetching = ref(false);
  const updating = ref(false);

  const { showSnackbar } = useSnackbar();

  const getSupportRequirements = async (): Service[] => {
    if (fetching.value) return;

    supportRequirements.value = [];
    fetching.value = true;

    const { data } = await supportRequirementService.getSupportRequirements();

    supportRequirements.value = data.value || [];
    fetching.value = false;

    return supportRequirements.value;
  };

  const updateSupportRequirements = async (form: Service[]) => {
    if (updating.value) return;

    updating.value = true;
    const { data, error } = await supportRequirementService.updateSupportRequirements(form);
    updating.value = false;

    if (error.value) {
      showSnackbar({
        text: error.value,
        state: false,
      });
    } else {
      return data.value.data;
    }
  };

  return {
    supportRequirements,
    fetching,
    updating,

    getSupportRequirements,
    updateSupportRequirements,
  };
}
